// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ou-1";
export var stateContainer = "_ou-0";